import { render, staticRenderFns } from "./homeView.vue?vue&type=template&id=6d79fe69&"
import script from "./homeView.vue?vue&type=script&lang=js&"
export * from "./homeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/menu/multiPage/homeView.vue"
export default component.exports